/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileUnknownAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h10v2H4V2h10.414zM15 7h1.586L15 5.414zm5 15h-2v-2h2z" />
        <path d="M19 12c.78 0 1.536.27 2.103.81.575.547.897 1.316.897 2.19 0 .847-.302 1.596-.846 2.14a2.883 2.883 0 0 1-1.154.702V19h-2v-1.9c0-.618.495-1.077 1.059-1.101l.11-.01a.965.965 0 0 0 .57-.262c.142-.141.261-.369.261-.727 0-.369-.126-.6-.275-.742-.157-.15-.401-.258-.725-.258s-.568.109-.725.258C18.126 14.4 18 14.63 18 15h-2c0-.874.322-1.643.896-2.19.568-.54 1.323-.81 2.104-.81z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileUnknownAlt as FileUnknownAlt };
